class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._addEventListeners();
    this._updateTabActive();
    this._updateProps();
  }

  _addEventListeners() {
    this.addEventListener('click', (e) => {
      if (!e.target.hasAttribute('aria-controls')) return;
      const currentTab = this.querySelector('.tab[aria-expanded="true"]');
      const target = e.target;

      this._updateProps(currentTab, target);
    });

    this.querySelectorAll('[data-modal-id]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const modal = document.getElementById(tab.dataset.modalId);
        if (!modal) return;
        modal.toggleAttribute('open');

        if (!modal.hasAttribute('open')) return;

        window.scrollTo({
          top: tab.parentElement.offsetTop - window.theme.readHeights().headerHeight,
          behavior: 'smooth'
        });
      });
    });
  }

  _updateProps(currentTab = this.querySelector('.tab[aria-expanded="true"]'), target = null) {
    const openIndex = this.getAttribute('data-open-tab');

    if (openIndex && !target) {
      target = this.querySelector(`.tab[aria-expanded="false"]:nth-child(${openIndex})`);
      this.removeAttribute('data-open-tab');
    } else if (!target) {
      target = this.querySelector('.tab[aria-expanded="false"]');
    }

    currentTab?.setAttribute('aria-expanded', false);
    currentTab?.ariaControlsElements[0].setAttribute('aria-hidden', true);

    target?.setAttribute('aria-expanded', true);
    target?.ariaControlsElements[0].setAttribute('aria-hidden', false);
    this._updateTabActive(target);
  }

  _updateTabActive(currentTab = this.querySelector('.tab[aria-expanded="true"]')) {
    if (!currentTab) return;
    const parent = currentTab.parentElement;
    const parentRect = parent.getBoundingClientRect();
    const tabRect = currentTab.getBoundingClientRect();
    const offset = tabRect.left - parentRect.left;

    this.style.setProperty('--tab-top', `${tabRect.top - parentRect.top}px`);
    this.style.setProperty('--tab-left', `${offset}px`);
    this.style.setProperty('--tab-width', `${currentTab.offsetWidth}px`);
    this.style.setProperty('--tab-height', `${currentTab.offsetHeight}px`);
  }
}

customElements.define('product-tabs', ProductTabs);